import AnalyticsIcon from './AnalyticsIcon.svg'
import BookingDashboardIcon from './BookingDashboardIcon.svg'
import BookingsIcon from './BookingsIcon.svg'
import CalenderIcon from './CalenderIcon.svg'
import ContractsIcon from './ContractsIcon.svg'
import CustomerIcon from './CustomerIcon.svg'
import DashboardIcon from './DashboardIcon.svg'
import DomainsIcon from './DomainsIcon.svg'
import EditorIcon from './EditorIcon.svg'
import FinanceIcon from './FinanceIcon.svg'
import GalleriesIcon from './GalleriesIcon.svg'
import HelpIcon from './HelpIcon.svg'
import PackageIcon from './PackageIcon.svg'
import ProfileIcon from './ProfileIcon.svg'
import QuestionnairesIcon from './QuestionnairesIcon.svg'
import ReferralsIcon from './ReferralsIcon.svg'
import SettingIcon from './SettingIcon.svg'
import WebsiteIcon from './WebsiteIcon.svg'
import threeVerticalDots from './threeVerticalDots.svg'

import emailIcon from './emailIcon.svg'
import callIcon from './callIcon.svg'
import statusIcon from './statusIcon.svg'
import downloadIcon from './downloadIcon.svg'
import editIcon from './editIcon.svg'

import finance from './finance.svg'
import plans from './plans.svg'
import security from './security.svg'
import referral from './referral.svg'
import help from './help.svg'
import messageIcon from './messageIcon.svg'
import AIAssistant from './AIAssistant.svg'
import CameraIcon from './CameraIcon.svg'

import placeholderlogo from './placeholderlogo.png'

import reminder from './reminder.svg'
import paymentReminder from './paymentReminder.svg'
import editBooking from './editBooking.svg'
import eyeIcon from './eyeIcon.svg'
import copylink from './copylink.svg'
import archive from './archive.svg'
import cancel from './cancel.svg'
import revert from './revert.svg'
import Ellipse from './Ellipse.svg'
import ascending from './ascending.svg'
import descending from './descending.svg'
import search from './search.svg'

import homeIcon from './homeIcon.svg'
import facebook from './facebook.svg'
import message from './message.svg'
import phone from './phone.svg'
import ratingStar from './ratingStar.svg'
import avtarDefaultImage from './avtarDefaultImage.svg'
import headerCoverPlaceholder from './headerCoverPlaceholder.svg'
import focalCoverImg from './focalCoverImg.png'
import headerCoverPhoto from './headerCoverProfile.png'
import messagesImg from './messagesIcon.svg'

export const CustomersImages = {
  eyeIcon,
  emailIcon,
  callIcon,
  statusIcon,
  downloadIcon,
  editIcon,
}

export const TabIcons = {
  AnalyticsIcon,
  BookingDashboardIcon,
  BookingsIcon,
  CalenderIcon,
  ContractsIcon,
  CustomerIcon,
  DashboardIcon,
  DomainsIcon,
  EditorIcon,
  FinanceIcon,
  GalleriesIcon,
  HelpIcon,
  PackageIcon,
  ProfileIcon,
  QuestionnairesIcon,
  ReferralsIcon,
  SettingIcon,
  WebsiteIcon,
}

export const GalleryImages = {
  threeVerticalDots,
}

export const formImages = {
  HelpIcon,
  ContractsIcon,
  QuestionnairesIcon,
  threeVerticalDots,
}

export const settingIcons = {
  finance,
  plans,
  security,
  referral,
  help,
  messageIcon,
  AIAssistant,
}

export const profilePageIcons = {
  CameraIcon,
  placeholderlogo,
  avtarDefaultImage,
  headerCoverPlaceholder,
  focalCoverImg,
  messagesImg,
  headerCoverPhoto,
}

export const BookingIcons = {
  copylink,
  editBooking,
  eyeIcon,
  reminder,
  paymentReminder,
  archive,
  revert,
  cancel,
  Ellipse,
  ascending,
  descending,
  search,
}

export const publicViewBookingIcons = {
  homeIcon,
  facebook,
  message,
  phone,
  avtarDefaultImage,
  ratingStar,
}
